import { render, staticRenderFns } from "./PanelKanbanShimmer.vue?vue&type=template&id=534ea07d"
import script from "./PanelKanbanShimmer.vue?vue&type=script&lang=js"
export * from "./PanelKanbanShimmer.vue?vue&type=script&lang=js"
import style0 from "./PanelKanbanShimmer.vue?vue&type=style&index=0&id=534ea07d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports